import monaLisa from '../../assets/hum1020/monalisa.jpg';
import bernini from '../../assets/hum1020/santa-teresa-bernini.jpg';
import concert from '../../assets/hum1020/concert.png';

export default [
  {
    isAssignment: true,
    link: 'renaissance',
    name: 'Renaissance',
    image: monaLisa,
  },
  {
    isAssignment: true,
    link: 'baroque',
    name: 'Italian/Roman Catholic Baroque',
    image: bernini,
  },
  {
    isAssignment: true,
    link: 'concert',
    name: 'Concert',
    image: concert,
  },
];
